import { FormEvent, useState } from 'react';
import { api } from '../api';
import { LocaleSelect, useI18n } from '../i18n';
import { localizedError } from '../i18n/errors';

export function BootstrapPage({ onComplete }: { onComplete: () => void }) {
  const { locale } = useI18n();
  const [email, setEmail] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [password, setPassword] = useState('');
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const copy = locale === 'zh-CN' ? {
    title: '初始化系统', subtitle: '创建第一个主管理员。完成后，这个入口会自动关闭。',
    name: '名称', email: '邮箱', password: '密码', creating: '创建中…', create: '创建主管理员',
    tokenLabel: '初始化密钥', tokenHelp: '初始化密钥由部署环境提供。'
  } : {
    title: 'Set up the system', subtitle: 'Create the first administrator. This setup page closes automatically when finished.',
    name: 'Name', email: 'Email', password: 'Password', creating: 'Creating…', create: 'Create administrator',
    tokenLabel: 'Setup key', tokenHelp: 'The setup key is provided by the deployment environment.'
  };

  async function submit(event: FormEvent) {
    event.preventDefault(); setBusy(true); setError('');
    try { await api.bootstrap({ email, displayName, password, token }); onComplete(); }
    catch (err) { setError(localizedError(err, locale, { 'zh-CN': '初始化失败', en: 'Bootstrap failed' })); }
    finally { setBusy(false); }
  }

  return <main className="auth-layout">
    <section className="auth-intro">
      <div className="auth-locale"><LocaleSelect /></div>
      <span className="eyebrow">Menu Lab</span><h1>{copy.title}</h1><p>{copy.subtitle}</p>
    </section>
    <form className="auth-card" onSubmit={submit}>
      <label>{copy.name}<input value={displayName} onChange={event => setDisplayName(event.target.value)} autoComplete="name" required /></label>
      <label>{copy.email}<input type="email" value={email} onChange={event => setEmail(event.target.value)} autoComplete="email" required /></label>
      <label>{copy.password}<input type="password" minLength={12} value={password} onChange={event => setPassword(event.target.value)} autoComplete="new-password" required /></label>
      <label>{copy.tokenLabel}<input type="password" value={token} onChange={event => setToken(event.target.value)} autoComplete="off" required /></label>
      {error && <p className="form-error">{error}</p>}
      <button className="primary-button" disabled={busy}>{busy ? copy.creating : copy.create}</button>
      <small>{copy.tokenHelp}</small>
    </form>
  </main>;
}
